import Lista from './Lista';

export const TransacaoLista = Lista;
